import { useState, useContext, useEffect } from 'react'

import { FeatureFlag } from './FF4JProvider'

const useFeatureFlag = (flagKey, defaultValue = false) => {
    const ff4j = useContext(FeatureFlag)

    if (!ff4j) {
        throw new Error('useFeatureFlag must be used inside of a FF4JProvider')
    }

    const [enable, setEnable] = useState(() =>
        ff4j.resolveFeature(flagKey, defaultValue)
    )

    useEffect(() => {
        const updateHandle = () => {
            const nextValue = ff4j.resolveFeature(flagKey, defaultValue)

            if (nextValue !== enable) {
                setEnable(nextValue)
            }
        }

        ff4j.on('update', updateHandle)
        return () => {
            ff4j.off('update', updateHandle)
        }
    }, [enable])

    return enable
}

export default useFeatureFlag
